import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  fetchJobEnquiry,
  getInitialCostSheet,
  postJobOrderCreate,
} from "./RecAgencyFunction";
import { useDispatch } from "react-redux";
import CostSheetView from "./CostSheet";
import { useOutletContext } from "react-router-dom";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";

export default function ConvertJobOrderPopup({
  showPromptElement,
  setShowPromptElement,
  setAgencyData,
}) {
  const dispatch = useDispatch();
  const { recAgencyId, jobEnquiryId } = showPromptElement;
  const [initialState, setInitialState] = useState();
  const [optionArrays, setOptionArrays] = useState({});
  const [costSheetData, setCostSheetData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState();
  const [finalData, setFinalData] = useState({});
  const [rowEdited, setRowEdited] = useState(false);
  useEffect(() => {
    fetchJobEnquiry(
      jobEnquiryId,
      setInitialState,
      setOptionArrays,
      setDataLoading,
      dispatch
    );
  }, []);

  useEffect(() => {
    if (!dataLoading) {
      const initialCostSheetData = getInitialCostSheet(initialState);
      setCostSheetData(initialCostSheetData);
    }
  }, [dataLoading]);

  const handleSubmit = () => {
    setSubmitLoading(true);
    if (!rowEdited) {
      setShowPromptElement((p) => ({ open: false }));
    }

    const body = {
      project_job_enquiry_id: jobEnquiryId,
      job_enquiry_recruitment_agency_id: recAgencyId,
      ...finalData,
    };
    postJobOrderCreate(
      body,
      setAgencyData,
      setSubmitLoading,
      dispatch,
      setShowPromptElement
    );
  };

  console.log(finalData, "finalData");
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xs sm:max-w-md md:max-w-xl lg:max-w-2xl xl:max-w-7xl w-full h-auto min-h-[15rem] uppercase p-5  rounded-md bg-white ">
        <div className="flex justify-between items-center font-semibold text-slate-500">
          {" "}
          <h2 className="text-left float-left">UPDATE EDOC VALUES</h2>
          <AiOutlineCloseCircle
            onClick={() => {
              setShowPromptElement((p) => ({ ...p, open: false }));
            }}
            className="float-right text-right"
          />
        </div>
        {!dataLoading ? (
          <div className="w-full text-center  mt-5 ">
            <CostSheetView
              defaultRows={costSheetData}
              setData={setFinalData}
              setRowEdited={setRowEdited}
              optionArrays={optionArrays}
            />
            <button
              className="p-2 max-w-xs-ultra w-full uppercase  rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              disabled={submitLoading}
              onClick={() => handleSubmit()}
            >
              {submitLoading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        ) : (
          <LoadingWithLable />
        )}
      </div>
    </div>
  );
}
